import React from "react";
import { ISubHeadingData, ISurgicalData } from "../../exports/interfaces";
import { marked } from "marked";
import { Fade } from "react-awesome-reveal";
import { useLoader } from "../../context/LoaderContext";
import { useUserDataContext } from "../../context/UserDataContext";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";

const DynamicSurgicalDescription = ({
  descriptionData,
  subHeadingData,
}: {
  descriptionData: ISurgicalData[];
  subHeadingData: ISubHeadingData;
}) => {
  const { loading } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const { userData } = useUserDataContext();

  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };

  return (
    <section style={{ paddingBottom: "90px" }}>
      <div className="container">
        <div className="row">
          {descriptionData.map((data, index) => {
            const isEven = index % 2 === 0;

            return (
              <section key={index} style={{ padding: "90px 0 0px" }}>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div style={{ width: "100%", position: "relative" }}>
                        {/* Floated image */}
                        <div
                          className="about-page__left wow slideInLeft"
                          data-wow-delay="100ms"
                          data-wow-duration="2500ms"
                          style={{
                            float:
                              !mobile && !tab
                                ? isEven
                                  ? "left"
                                  : "right"
                                : "unset",
                            width: !mobile && !tab ? "45%" : "100%",
                            marginRight:
                              !mobile && !tab
                                ? isEven
                                  ? "50px"
                                  : "0"
                                : "auto",
                            marginLeft:
                              !mobile && !tab
                                ? !isEven
                                  ? "50px"
                                  : "0"
                                : "auto",
                            marginBottom: "1rem",
                          }}
                        >
                          {!loading && (
                            <Fade
                              cascade
                              damping={0.2}
                              direction={isEven ? "left" : "right"}
                              triggerOnce={true}
                            >
                              <div className="about-page__img">
                                <img
                                  src={data?.attributes?.Image?.data?.attributes?.url &&`${process.env.REACT_APP_strapiUrl}${data?.attributes?.Image?.data?.attributes?.url}`}
                                  alt="about"
                                  style={{
                                    objectFit: "cover",
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "489px",
                                    objectPosition: "top",
                                  }}
                                />
                                {index === 0 && (
                                  <div className="mt-2">
                                    <h3 className="custom-image-name">
                                      {subHeadingData?.attributes?.Doctor_Name}
                                    </h3>
                                    <p style={{ marginBottom: "unset" }}>
                                      {
                                        subHeadingData?.attributes
                                          ?.Doctor_Position
                                      }
                                    </p>
                                  </div>
                                )}
                              </div>
                            </Fade>
                          )}
                        </div>
                        <div>
                          <div
                            className="section-title text-left"
                            style={{ marginBottom: "36px" }}
                          >
                            <h2 className="section-title__title">
                              {data?.attributes?.Title}
                            </h2>
                          </div>
                          <p
                            className="about-page__text"
                            style={{ textAlign: "justify" }}
                            dangerouslySetInnerHTML={{
                              __html: marked(
                                data?.attributes?.Description || ""
                              ) as string,
                            }}
                          ></p>
                          {/* <div style={{ clear: "both" }}></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            );
          })}

          {/* Consent Form Section */}
          {subHeadingData?.attributes?.Consent_Letter?.data && userData ? (
            <div
              className="become-volunteer__btn-box"
              style={{ marginTop: "40px", paddingLeft: "15px" }}
            >
              <a
                href={`${process.env.REACT_APP_strapiUrl}${subHeadingData?.attributes?.Consent_Letter?.data?.attributes?.url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="thm-btn become-volunteer__btn"
              >
                Download Consent Form
              </a>
            </div>
          ) : !userData ? (
            <div
              className="become-volunteer__btn-box"
              style={{ marginTop: "40px" }}
            >
              <p>Become a Member to Download Consent Form</p>
              <Link
                to="/become-a-member"
                className="thm-btn main-header-two__btn custom-donate-btn"
                style={{ paddingLeft: "5px" }}
                onClick={() => linkClicker("become-a-member")}
              >
                <i className="icon-user-plus"></i>
                Become a Member
              </Link>
            </div>
          ) : (
            <div
              // className="become-volunteer__btn-box"
              // style={{ marginTop: "40px" }}
            >
              {/* <p>No Consent Form Available</p> */}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default DynamicSurgicalDescription;
